import React from "react";
import styled from "styled-components";
import { focusPickerSearch } from "utils/inputs";
import { Form } from "rsuite";

const widthValues = {
    "md": "200px"
};


class CustomField extends React.PureComponent {
    render() {
        const {
            name, message, label, labelWidth, accepter, error, width, useBr, withCheckbox,
            style: style_, mr, styleFormGroupExternal, styleLabelExternal, icon, inline, ...props
        } = this.props;

        const style = style_ ? { ...style_ } : {};

        if (width) {
            style.width = widthValues[width] || width;
        }
        const styleFormGroup = {
            ...(inline ? { display: "inline-flex", alignItems: "center" } : {}),
            ...styleFormGroupExternal
        };
        (mr) && (styleFormGroup.marginRight = mr);

        const propsLabel = {
            style: {
                marginRight: 8,
                marginBottom: 0,
                ...(inline ? { flexShrink: 0, whiteSpace: "nowrap" } : {}),
                ...styleLabelExternal
            }
        };
        if (labelWidth) {
            propsLabel.style.width = labelWidth;
        }

        return (
            <>
                <StyledFormGroup className={error ? "has-error" : ""} style={styleFormGroup} hasIcon={!!icon}>
                    {label &&
                        <Form.ControlLabel {...propsLabel} >{label} </Form.ControlLabel>
                    }
                    <Form.Control
                        name={name}
                        accepter={accepter}
                        errorMessage={error}
                        errorPlacement="topRight"
                        {...props}
                        onOpen={() => {
                            if (props.onOpen) props.onOpen();
                            if (props.searchable === false) return;

                            focusPickerSearch();
                        }}
                        style={style}
                    />
                    {icon ? <span className="custom-field__icon">{icon}</span> : <></>}
                    {message && <Form.HelpText>{message}</Form.HelpText>}
                </StyledFormGroup>
                {useBr && <br />}
            </>
        );
    }
}


export default CustomField;

const StyledFormGroup = styled(Form.Group)`
    && {
        .custom-field__icon {
            position: absolute;
            right: 10px;
        }
        .rs-icon {
            color: var(--color-green);
        }
    }
`;
